<template>
  <div>
    REGISTER PERURI
    <hr>
    <b-form-group :class="{'error-input' : $v.data_register_peruri.title.$error}">
      <label> Register Peruri Title </label>
      <j-input
        v-model="$v.data_register_peruri.title.$model"
        :max-length="255"
        placeholder="Register Peruri Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeRegisterPeruri">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveRegisterPeruri">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_register_peruri: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_register_peruri: {
        title: '',
      },
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_channel']),

    generateDataRegisterPeruri() {
      const infoName = this.data_register_peruri.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_register_peruri.title,
        widget_master_id: this.dataMaster.id,

        type: 3,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataRegisterPeruriUpdate() {
      const infoName = this.data_register_peruri.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_register_peruri.title,
        widget_master_id: this.dataMaster.id,

        type: 3,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_register_peruri.title = JSON.parse(this.dataEdit.info).name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    saveRegisterPeruri() {
      this.$v.data_register_peruri.$touch();
      if (!this.$v.data_register_peruri.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataRegisterPeruri;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataRegisterPeruriUpdate;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeRegisterPeruri();
      }
    },

    closeRegisterPeruri() {
      this.$emit('close-field');
      this.data_register_peruri.title = null;
      setTimeout(() => {
        this.$v.data_register_peruri.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jRegisterPeruriSetup.vue